import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const AlertTriangle: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M12 8.5V14.5M12 16.5V18.5M12 2.08594L22.3174 21H1.68262L12 2.08594Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default AlertTriangle
